export const extractClientMatterNumbers = ({ clientMatterNo }) => {
  if (!clientMatterNo || typeof clientMatterNo !== 'string') {
    return null
  }

  if (!clientMatterNo.includes('-')) {
    return { clientNo: clientMatterNo, matterNo: null }
  }

  const clientMatterNoParts = clientMatterNo.split('-')

  // matterNo is the last part of the clientMatterNo
  const lastIndexOfClientMatterNoParts = clientMatterNoParts.length - 1
  const matterNo = Number(clientMatterNoParts[lastIndexOfClientMatterNoParts])

  // clientNo is the clientMatterNo without the matterNo
  const clientNo = clientMatterNoParts.slice(0, lastIndexOfClientMatterNoParts).join('-')

  return { clientNo, matterNo }
}
